import React, { ForwardedRef, forwardRef } from 'react';
import { GridContainer } from './Grid.styles';
import { ColumnProps } from '../Column.styles';
import { SpacingProps } from '../Spacing.styles';
import { componentPropsToStyledProps } from 'src/app/styles/helper';
import { MaxWidthProps } from '../MaxWidth.styles';
import { VisibilityProps } from '../Visibility.styles';
import { ColorModePropKeys, DataColorMode } from 'src/app/styles/colors';

export interface GridProps extends ColumnProps, SpacingProps, MaxWidthProps, VisibilityProps {
  children: React.ReactNode;
  totalColumns?: number;
  totalColumnsSm?: number;
  totalColumnsMd?: number;
  totalColumnsLg?: number;
  totalColumnsXl?: number;
  totalColumns2xl?: number;
  id?: string;
  className?: string;
  position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  background?: ColorModePropKeys;
  border?: string;
  dataColorMode?: DataColorMode;
  dataCy?: string;
}

const Grid = (
  { children, className, id, dataColorMode, dataCy, ...props }: GridProps,
  forwardedRef: ForwardedRef<HTMLDivElement>
): JSX.Element => {
  const childrenArray = React.Children.toArray(children);
  const totalChildren = childrenArray.length;

  return (
    <GridContainer
      id={id}
      data-cy={dataCy}
      className={className}
      $totalChildren={totalChildren}
      ref={forwardedRef}
      data-color-mode={dataColorMode}
      {...componentPropsToStyledProps(props)}
    >
      {children}
    </GridContainer>
  );
};

export default forwardRef(Grid);
